import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { Integrator } from './types'

export const fetchDropDownIntegratorList = async (params?: { abortCtrl?: AbortController | AbortSignal, clientIds?: string }) => {
  return wretchClient
    .url('/admin/1.0/integrators')
    .signal(params?.abortCtrl)
    .query(params?.clientIds ? { clientIds: params.clientIds } : {})
    .get()
    .json<{ list: Integrator[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const addIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators`)
    .post(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addHostAdminIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators/by-host-admin`)
    .post(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators`)
    .put(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateHostAdminIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators/by-host-admin`)
    .put(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteIntegrator = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/integrators/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchIntegratorDetails = async (params: { id: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/integrators/${params.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<{ data: Integrator[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
